import React from 'react';

const SvgNaviconHoroscopes = (props) => {
  return (
    <svg viewBox="0 0 95.61 94.71" {...props}>
      <style>
        {
          `.navicon_horoscopes_svg__st1{fill:none;stroke:#000;stroke-width:3.61;stroke-linecap:round;stroke-miterlimit:10;enable-background:new}`
        }
      </style>
      <circle
        cx={47.81}
        cy={47.81}
        r={18.94}
        fill="none"
        stroke="#000"
        strokeWidth={3.19}
        strokeMiterlimit={10}
      />
      <path
        className="navicon_horoscopes_svg__st1"
        d="M47.81 1.8v18.95M47.81 73.97V92.9M1.8 47.81h18.95M74.86 47.81h18.95M13.8 14.25l13.38 13.39M68.43 67.97l13.39 13.39M13.8 81.36l13.38-13.39M68.43 27.64l13.39-13.39"
      />
    </svg>
  );
};

export default SvgNaviconHoroscopes;
